import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d48e1a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app_navbar" }
const _hoisted_2 = { class: "app_navbar_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-label" }, "北京神墨文化传播有限公司", -1))
const _hoisted_4 = { class: "navbar_container" }

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavBar',
  setup(__props) {

const router = useRouter();
const todo = (url: string) => {
  router.push(url);
};

// const link = (url: string) => {
//   location.href = url;
// };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "navbar_link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (todo('/')))
        }, "首页"),
        _createElementVNode("div", {
          class: "navbar_link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (todo('/news')))
        }, "付费资讯"),
        _createElementVNode("div", {
          class: "navbar_link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (todo('/about')))
        }, "关于我们"),
        _createElementVNode("div", {
          class: "navbar_link",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (todo('/login')))
        }, "登陆")
      ])
    ])
  ]))
}
}

})